import type { Chart as ChartJS, ChartType, Plugin } from "chart.js"

interface StripeDefinition {
	min: number
	max: number
	color: string
}

declare module "chart.js" {
	interface PluginOptionsByType<TType extends ChartType> {
		bgColorHorizontal?: {
			stripes: StripeDefinition[]
			yAxisRef?: string
		}
	}
}

export const bgColorHorizontalPlugin: Plugin<"line" | "bar"> = {
	id: "bgColorHorizontal",
	beforeDraw: (
		chart: ChartJS,
		args: { cancelable: true },
		pluginOptions: {
			stripes: StripeDefinition[]
			yAxisRef?: string
		}
	) => {
		const { ctx, chartArea, scales } = chart
		const { top, bottom, left, width } = chartArea
		const offset = 1
		const xAxis = chart.scales["x"] // Assumes the x-axis scale ID is 'x'
		if (xAxis === undefined) return
		// xAxis.ctx.save()
		// xAxis.ctx.translate(offset, 0)
		// xAxis.ctx.restore()
		// Move the x-axis line (the baseline of the x-axis)
		// xAxis.left += offset
		// xAxis.right += offset
		// chartArea.left += offset
		// xAxis.drawGrid(chartArea)
		// xAxis.drawLabels(chartArea)
		const { stripes, yAxisRef } = pluginOptions
		if (stripes === undefined || stripes.length === 0) {
			return
		}

		const yScale = scales[yAxisRef ?? "y"]
		if (yScale === undefined || yScale === null) {
			return
		}

		stripes.forEach(({ min, max, color }) => {
			const y1 = yScale.getPixelForValue(min)
			const y2 = yScale.getPixelForValue(max)

			const stripeTop = Math.min(y1, y2)
			const stripeBottom = Math.max(y1, y2)
			const stripeHeight = stripeBottom - stripeTop

			const clampedTop = Math.max(top, stripeTop)
			const clampedBottom = Math.min(bottom, stripeBottom)
			const clampedHeight = clampedBottom - clampedTop

			if (clampedHeight <= 0) {
				return
			}

			ctx.save()
			ctx.fillStyle = color
			ctx.fillRect(left, clampedTop, width, clampedHeight)
			ctx.restore()
		})
	},
}
